import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("video2", component(opts));
  editor.BlockManager.add("video2", block(opts));
};